exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  z-index: 100; }\n\n.number-input {\n  border: 1px solid #000;\n  width: 40px;\n  height: 25px;\n  padding: 0 5px;\n  margin: 0 10px; }\n\n.weekly md-checkbox {\n  margin-left: 8px; }\n\n.weekdays {\n  width: 60%;\n  font-size: 13px; }\n\n.aligned-select {\n  display: block;\n  float: right;\n  margin-left: 10px;\n  margin-top: -13px; }\n\n.yearly2 div {\n  float: left; }\n\n.yearly2 md-select {\n  float: left;\n  margin-top: -18px;\n  margin-left: 10px; }\n\n.errors {\n  font-family: 'Roboto', sans-serif;\n  color: #E55049; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/new-consigna-dialog/repetir-subdialog.component.scss
// module id = ../../../../../src/app/components/agenda/new-consigna-dialog/repetir-subdialog.component.scss
// module chunks = 0